import dataBeleidHuisarts from "../../../../src/data/beleid-bloedingen-bij-de-huisarts.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  dataBeleidHuisarts,
  BasicCollapse,
  React
};